import PropTypes from 'prop-types';
import React from 'react';

const ViewLink = props => {
	const isGlobal = !props.bookmark.isGlobal;
	const isDisabled = !props.isAdmin && isGlobal && !props.allowAll;
	return isDisabled ? (
		<div className="list-icon-btn">
			<i title={props.title} alt={props.alt} className={`material-icons disabled`}>
				{props.iconName}
			</i>
		</div>
	) : (
		<div className="list-icon-btn">
			<i title={props.title} alt={props.alt} className="material-icons" onClick={props.onClick}>
				{props.iconName}
			</i>
		</div>
	);
};

ViewLink.propTypes = {
	bookmark: PropTypes.object,
	isAdmin: PropTypes.bool,
	allowAll: PropTypes.bool,
	title: PropTypes.string,
	alt: PropTypes.string,
	iconName: PropTypes.string,
	onClick: PropTypes.func,
};

export default ViewLink;
